module.exports = __webpack_public_path__ + "static/media/8x8-logo.28467619.svg";